/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

document.getElementById('shopify-section-template--15937726251194__slideshow').onclick = function(event) {
    window.location.href = 'https://jacoblee.london/collections/fall-winter-2023-2024';
};
(function() {
  // Add custom code below this line

  $( document ).ready(function() {
    $(".d-location").click(function() {
      $(".gep-switcher").click();
    });

    $(".header-country strong").click(function() {
      $(".gep-switcher").click();
    });

    setTimeout(function() {
      $(".d-location strong").html(GEP.countryName);
      $(".header-country strong").html(GEP.countryName);
    }, 3000);
    
    $(".arrow-desc ,.arrow-ship, .product__sharing-button-may-we-help").click( function() {
      $(window).scrollTop(0);
    });
  });




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



//drashti

$(document).ready(function() {
  $(".accordion-row .accordion-toggle").removeClass("is-open");
  $(".accordion-row .accordion-content").css("display","none");



});


$("input[name='options[Color]']").click(function() {
  $(this).each(function(){
    if($(this).is(":checked")){
      var target_val = $(this).val();
      $(".color-picker__label.color").text(target_val);
   
    }
  });
});


$("input[name='options[Size]']").click(function() {
  $(this).each(function(){
    if($(this).is(":checked")){
     var target_val = $(this).val();

      $(".color-picker__label.size").text(target_val);
    }
  });
});

$(".radio__fieldset .radio__button label").on('click', function() {
  $(".radio__fieldset .radio__button label").removeClass('checkedlabel');
  $(this).addClass('checkedlabel');
  $(".color-picker__label.size").addClass('add-size');
  
});

$(document).ready(function() {
  
  
  setTimeout(function() {
    $("input:radio[name='options[Size]']").each(function(i) {
     $(this).first().prop('checked', false);
       $(".color-picker__label.size").css("display" , "none"); 
    });
  }, 500);
});

$(".arrow-desc").on('click', function() {
  $(".desc_popup").addClass('desc--add');
  $("body").addClass('product-share-button--modal-open');
  $(".product__form").hide();
  $(".popup-desc-ship").addClass('product-details__desc--modal-open ');
  $(".form__wrapper").addClass('product-details__desc--modal-open');
  $(".pro_desc_popup").show();
  $(".pro_desc_popup").css("visibility" , "visible");
}); 

$(".arrow-ship").on('click', function() {
  $(".desc_popup").addClass('shipping--add');
  $("body").addClass('product-share-button--modal-open');
  $(".popup-desc-ship").addClass('product-details__desc--modal-open');
  $(".product__form").hide();
  $(".pro_desc_shipping").show();
  $(".form__wrapper").addClass('product-details__desc--modal-open');
  $(".pro_desc_shipping").css("visibility" , "visible");
}); 

$(".product__sharing-button-may-we-help").on('click', function() {
  $(".desc_popup").addClass('contact--add');
  $("body").addClass('product-share-button--modal-open');
  $(".product__form").hide();
  $(".pro_contact_popup").show();
  $(".popup-desc-ship").addClass('product-details__desc--modal-open');
  $(".form__wrapper").addClass('product-details__desc--modal-open');
}); 

$(".pdp-modal__button-close").click(function(){
  $(".desc_popup").removeClass('desc--add');
  $("body").removeClass('product-share-button--modal-open');
  $(".form__wrapper").removeClass('product-details__desc--modal-open');
  $(".popup-desc-ship").removeClass('product-details__desc--modal-open');
  $(".product__form ").css("display", "block");
  $(".pro_desc_popup").css("display" , "none");
  $(".pro_desc_shipping").css("display" , "none");
  $(".pro_contact_popup").css("display" , "none");
  $(".desc_popup").removeClass('shipping--add');
  $(".desc_popup").removeClass('contact--add');
});

$(".radio__button.variant-input").click(function() {
  $(".color-picker__label.size").css("display" , "block");         
});


$(".size-guide-panel__size-help-link").on("click", function(e) {
     event.preventDefault();
  $(".scr-open-size-chart").trigger("click");
});

$(document).ready(function(){
  $('video').attr('id', 'vid');
  $('#pages').on('change', function() {
    var getUrl = $(this).val();
    location.replace(getUrl);
  });



      
});





var vides = document.getElementById("vid");
vides.removeAttribute("controls");
console.log(vides);